import moment from 'moment';
import { Investment_UnitBillingPeriod } from 'types/common';

type BillingPeriod = 'DAY' | 'MONTH' | 'WEEK';

export function getEarliestStart(billingPeriod: BillingPeriod) {
  switch (billingPeriod) {
    case 'DAY':
      return moment().add(1, 'days');
    case 'WEEK':
      return moment().add(1, 'weeks').startOf('week');
    case 'MONTH':
      return moment().add(1, 'months').startOf('month');
  }
}

interface InvestmentPeriod {
  year: number;
  unit: Investment_UnitBillingPeriod;
  periodNumber: number;
}

export function periodToDate(period: InvestmentPeriod) {
  const date = moment();
  date.year(period.year);
  switch (period.unit) {
    case Investment_UnitBillingPeriod.MONTH:
      date.month(period.periodNumber - 1);
      return date.startOf('month');
    case Investment_UnitBillingPeriod.WEEK:
      date.isoWeek(period.periodNumber);
      return date.startOf('isoWeek');
    case Investment_UnitBillingPeriod.DAY:
      date.dayOfYear(period.periodNumber);
      return date.startOf('day');
  }
}

export function getNextStart(
  billingPeriod: Investment_UnitBillingPeriod,
  date: moment.Moment | Date | string
) {
  const result = moment(date);
  switch (billingPeriod) {
    case Investment_UnitBillingPeriod.MONTH:
      return result.add(1, 'month');
    case Investment_UnitBillingPeriod.WEEK:
      return result.add(1, 'weeks');
    case Investment_UnitBillingPeriod.DAY:
      return result.add(1, 'day');
  }
}
